import react, { useEffect, useRef, useState } from "react";
import "./polls.css";
import { Link, useNavigate } from "react-router-dom";
import { database } from "../../database/firebase";
import {
  getFirestore,
  increment,
  serverTimestamp,
  doc,
  getDoc,
  updateDoc,
  setDoc,
  collection,
  query,
  orderBy,
  where,
  getDocs,
  onSnapshot,
  listCollections,
} from "firebase/firestore";
import BarChart from "../chart/ChartJs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import UseHandleConnection from "../../functions/UseHandleConnection";
import { sendReport } from "./sendReports";
import Swal from "sweetalert2";



function Polls({ updateHeader }) {
  const navigate = useNavigate();
  const [isOpen, setOpen] = useState(false);
  const [themeData, setThemeData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [questionForm, setQuestionForm] = useState({});
  const [currentQueston, setCurrentQueston] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isQuestionCompleted, setIsQuestionCompleted] = useState(false);
  const [selectedOption, setSelectedOption] = useState("not_selected");
  const [barCharLables, setBarChartLables] = useState([]);
  const [barChartPercentages, setBarChartPercentages] = useState([]);
  const [showResults, setShowResults] = useState([]);
  const [waitingScreen, setWaitingScreen] = useState(false);
  const [totalAnswered, setTotalAnswered] = useState(0);
  const [isLive, setIsLive] = useState(false);
  const [addOption, setAddOption] = useState(false);
  const newOption = useRef(null);
  const [slideData, setSlideData] = useState(null);
  const [pointerTimestamp, setPointerTimestamp] = useState(null);
  const [finalReportPointer, setFinalReportPointer] = useState(null);
  const [showAniamtion, setShowAnimation] = useState(false);
  const [triggerFromLive, setTriggerFromLive] = useState(false);
  const [showQuestion, setShowQuestion] = useState(false);
  const [liveTimers, setLiveTimers] = useState(false);
  const [isTimeUp, setIsTimeUp] = useState(false);
  const [wordCloudInputDisabled, setWordCloudInputDisabled] = useState(false);

  const [counter, setCounter] = useState(3);
  const [animationRunning, setAnimationRunning] = useState(false);
  const circleRef = useRef(null);
  const questionIntroCompletedRef = useRef({});

  const [time, setTime] = useState("00:00");
  const intervalRef = useRef(null);

  const configureTimer = (initialTime) => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = null;
    setTime(initialTime);
    startTimer(initialTime);
  };

  const stopLocalTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const applyAdminTimer = (timerValue) => {
    stopLocalTimer();
    if (timerValue === undefined || timerValue === null) {
      setTime("--:--");
      return;
    }
    setTime(timerValue);
    if (timerValue === "00:00") {
      setIsTimeUp(true);
    } else {
      setIsTimeUp(false);
    }
  };

  
  const startTimer = (initialTime) => {
    let [minutes, seconds] = initialTime.split(":").map(Number); // Extract minutes and seconds
    let totalSeconds = minutes * 60 + seconds;

    intervalRef.current = setInterval(() => {
      console.log("interval triggering");
      if (totalSeconds <= 0) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        handleTimerExpired();
      } else {
        totalSeconds -= 1;
        const min = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
        const sec = String(totalSeconds % 60).padStart(2, "0");
        setTime(`${min}:${sec}`);
      }
    }, 1000);
  };

  const clearTimer = (resetDisplay = true) => {
    stopLocalTimer();
    if (resetDisplay) {
      setTime("--:--");
    }
  };

  const resetCircle = () => {
    const circleElement = circleRef.current;
    if (circleElement) {
      circleElement.style.transition = "none"; // Remove transition for instant reset
      circleElement.style.bottom = "-200px"; // Reset position to bottom
      circleElement.style.borderWidth = "10px"; // Reset border width
      circleElement.style.display = "none"; // Hide initially
      circleElement.classList.remove("blinking"); // Remove blinking class
      setTimeout(() => {
        circleElement.style.transition = "bottom 1s ease, border-width 1s ease"; // Reapply transition for smooth movement
        // setShowAnimation(false);
      }, 50); // Small delay to ensure transition reset
    }
  };

  // Function to start the circle animation

  const startCircleAnimation = () => {
    console.log("isaleady running", animationRunning);
    if (animationRunning) return; // Prevent starting a new animation if one is running
    setAnimationRunning(true); // Mark animation as running
    setCounter(3); // Reset the countdown to 3
    resetCircle(); // Reset the circle before starting
    setTriggerFromLive(false);
    const circleElement = circleRef.current;
    console.log(circleElement);
    if (circleElement) {
      circleElement.style.display = "flex"; // Show the circle

      setTimeout(() => {
        circleElement.style.bottom = "0"; // Move the circle up
        circleElement.style.borderWidth = "2px"; // Change the border width
      }, 100);

      // After movement completes, start blinking and countdown
      setTimeout(() => {
        circleElement.classList.add("blinking"); // Add blinking effect
        startCountdown();
      }, 1000); // Wait for the movement to complete
    }
  };

  // Function to start the countdown
  const startCountdown = () => {
    let interval = setInterval(() => {
      setCounter((prevCounter) => {
        if (prevCounter > 1) {
          return prevCounter - 1;
        } else {
          clearInterval(interval); // Stop the countdown when it reaches 0
          setTimeout(() => {
            setAnimationRunning(false); // Allow new animations to start
            resetCircle(); // Reset the circle for the next cycle
            setShowAnimation(false);
            setTime("--:--");
            if (questionForm?.isQuiz || questionForm?.isWordCloud) {
              if (currentQueston != null) {
                questionIntroCompletedRef.current[currentQueston] = true;
              }
              setShowQuestion(true);
              if (questionForm?.isLive) {
                applyAdminTimer(liveTimers?.[currentQueston]);
              } else {
                setTimeout(() => {
                  configureTimer(
                    questionForm?.questions[currentQueston]?.time || "00:30"
                  );
                }, 2000);
              }
            } else {
              if (currentQueston != null) {
                questionIntroCompletedRef.current[currentQueston] = true;
              }
              setShowQuestion(true);
            }
          }, 10); // Delay before hiding the circle

          return 3; // Reset counter for the next animation cycle
        }
      });
    }, 1000);
  };

  function triggerCircle() {
    startCircleAnimation();
  }

  UseHandleConnection({
    userId: userData?.userId,
    sessionId: userData?.sessionId,
    themeId: themeData?.themeName,
  });

  const initalizePolling = () => {
    if (userData != null) {
      listenTimers();
      listenThemeChange();
      console.log("cecking question form", questionForm);
      if (!questionForm.isLive) {
        const themeDocRef = doc(
          database,
          `sessions/${userData.sessionId}/themes/${themeData.themeName}`
        );
        console.log(
          `sessions/${userData.sessionId}/themes/${themeData.themeName}`
        );
        getDoc(themeDocRef)
          .then((themeSnapshot) => {
            if (themeSnapshot.exists()) {
              const themeDataFetch = themeSnapshot.data();
              setShowResults(themeDataFetch.showResults);
              setWaitingScreen(themeDataFetch.liveData.waiting);
              setIsLive(themeDataFetch.isLive);
              setIsTimeUp(false);

              if (themeDataFetch.liveData.waiting) {
                clearTimer();
              }

              console.log("First Loaded Question Form:", themeDataFetch);
              let getQuestionsLength = themeDataFetch.questions.length;

              if (themeDataFetch.isLive) {
                const slideDoc = doc(
                  database,
                  `sessions/${userData.sessionId}/reports/${themeData.themeName}`
                );
                getDoc(slideDoc).then((slideSnapshot) => {
                  if (slideSnapshot.exists()) {
                    setSlideData(slideSnapshot.data());
                    console.log(slideSnapshot.data());
                  }
                });
              }

              const finalReport = collection(database, "finalReport");
              const finalReportQuery = query(
                finalReport,
                where("userId", "==", userData.userId),
                where("sessionId", "==", userData.sessionId),
                where("themeId", "==", themeData.themeName)
              );

              getDocs(finalReportQuery)
                .then((querySnapshot) => {
                  if (querySnapshot.empty) {
                    // No existing document, create a new one
                    console.log("FINAL REPORT RUNNING ONCE");
                    const finalReportRef = doc(finalReport); // Firestore generates a unique document ID
                    setDoc(finalReportRef, {
                      name: userData.name,
                      themeId: themeData.themeName,
                      organizationId: userData.organizationId,
                      sessionId: userData.sessionId,
                      userId: userData.userId,
                      email: userData.email,
                      totalQuestions: 0,
                      source: userData.source,
                      totalPoints: 0,
                      totalTime: 0, // Initial count
                      timestamp: serverTimestamp(),
                    })
                      .then(() => {
                        return getDoc(finalReportRef); // Fetch the document after writing
                      })
                      .then((docSnapshot) => {
                        if (docSnapshot.exists()) {
                          const docData = docSnapshot.data();
                          console.log(docData);
                          const docId = finalReportRef.id;
                          setFinalReportPointer(docId);
                          console.log("updating pointer if user not exist");
                          setPointerTimestamp(docData.timestamp); // Use the accurate server timestamp
                          console.log(
                            "User added in final report with timestamp:",
                            docData.timestamp
                          );
                        } else {
                          console.error(
                            "Document does not exist after writing."
                          );
                        }
                      })
                      .catch((error) => {
                        console.error(
                          "Error adding user to final report:",
                          error
                        );
                      });
                  } else {
                    const getcurrentDoc = querySnapshot.docs[0]; // There should be only one entry
                    const existingTimestamp = getcurrentDoc.data().timestamp; // Get the existing timestamp
                    const docId = getcurrentDoc.id;
                    console.log("existing timestamp", existingTimestamp);
                    console.log("updating pointer if user exist");
                    setFinalReportPointer(docId);
                    setPointerTimestamp(existingTimestamp);
                  }
                })
                .catch((error) => {
                  console.error("Error querying documents: ", error);
                });

              let totalAnsweredAns = 0;
              const q = query(
                collection(database, "allReports"),
                where("sessionId", "==", userData.sessionId),
                where("themeId", "==", themeData.themeName),
                where("userId", "==", userData.userId),
                orderBy("currentQueston", "asc")
              );

              getDocs(q)
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) {
                    const data = querySnapshot.docs.map((doc) => ({
                      id: doc.id, // The document ID
                      ...doc.data(), // The document data
                    }));
                    console.log("New Data:", data); // Handle the fetched data here
                    console.log("total length", data.length); // Handle the fetched data here
                    totalAnsweredAns = data.length;
                    let processQuestions = themeDataFetch;
                    console.log("total answered", totalAnsweredAns);
                    setTotalAnswered(totalAnsweredAns);
                    for (let i = 0; i < getQuestionsLength; i++) {
                      let answered = false;
                      const isWordCloudMulti =
                        themeDataFetch.isWordCloud &&
                        themeDataFetch.questions[i]?.allowMultiple;
                      if (!isWordCloudMulti && data[i] != undefined) {
                        answered = true;
                      }
                      processQuestions.questions[i]["answered"] = answered;
                    }

                    setQuestionForm(processQuestions);
                  } else {
                    console.log("No matching documents found.");
                    setTotalAnswered(totalAnsweredAns);
                    setQuestionForm(themeDataFetch);
                  }
                })
                .catch((error) => {
                  console.error("Error fetching data:", error);
                });
            } else {
              console.log("No theme data found!");
            }
          })
          .catch((error) => {
            console.error("Error fetching theme data:", error);
            throw new Error("Failed to fetch theme data.");
          });
      }
    }
  };

  // useEffect(() => {
  //   initalizePolling();
  // }, [userData]);

  useEffect(() => {
    if (questionForm.questions != undefined) {
      console.log("trigger response");
      let getQuestionsLength = questionForm.questions.length;
      if (totalAnswered != getQuestionsLength) {
        console.log("my question form ", questionForm);
        setIsLoaded(true);
        setCounter(3);
        if (!questionForm.isLive) {
          console.log("this should work with live", totalAnswered);
          if (totalAnswered != 0) {
            console.log("current question setup", totalAnswered);
            setCurrentQueston(totalAnswered);
          } else {
            console.log("current question setup", totalAnswered);
            setCurrentQueston(totalAnswered);
          }
        } else {
          console.log("this is for live", questionForm);
          if (currentQueston == questionForm.liveData.slide) {
            afterUpdatingCurrentQuestion();
          } else {
            setCurrentQueston(questionForm.liveData.slide);
          }
        }
        setIsQuestionCompleted(false);
        console.log("show them");
      } else {
        setIsQuestionCompleted(true);
        setIsLoaded(true);
        setCounter(3);
        console.log("all questions completed!");
      }

      console.log("hitting this ", isLive);

      if (
        questionForm?.questions[currentQueston]?.answered &&
        !questionForm?.isWordCloud
      ) {
        fetchCounterLive(
          currentQueston,
          questionForm.questions[currentQueston].options.length,
          questionForm
        );
      }
    }
  }, [questionForm]);

  useEffect(() => {
    if (currentQueston != null) {
      setIsTimeUp(false);
      setWordCloudInputDisabled(false);
      delete questionIntroCompletedRef.current[currentQueston];
      clearTimer();
      afterUpdatingCurrentQuestion();
    }
  }, [currentQueston]);


// async function updateQuestionCount(
//   database,
//   userData,
//   themeData,
//   currentQuestion
// ) {
//   const ref = doc(
//     database,
//     `sessions/${userData.sessionId}/questionCount/${themeData.themeName}_${currentQuestion}`
//   );

//   console.log(
//     "updateQuestionCount path:",
//     `sessions/${userData.sessionId}/questionCount/${themeData.themeName}_${currentQuestion}`
//   );

//   const snap = await getDoc(ref);

//   if (snap.exists()) {
//     const data = snap.data();
//     if (!data[userData.userId]) {
//       await updateDoc(ref, {
//         [userData.userId]: true,
//         count: increment(1),
//       });
//     }
//   } else {
//     await setDoc(ref, {
//       [userData.userId]: true,
//       count: 1,
//     });
//   }
// }



  async function afterUpdatingCurrentQuestion() {
    console.log("current question", currentQueston);
    if (questionForm.questions != undefined && !isQuestionCompleted) {
      if (!questionForm.isWordCloud) {
        fetchCounterLive(
          currentQueston,
          questionForm.questions[currentQueston].options.length,
          questionForm
        );
      }
      console.log(questionForm?.questions[currentQueston].allowMultiple);
    }
    if (questionForm.isWordCloud) {
      setAddOption(true);
    } else {
      setAddOption(false);
    }
    setSelectedOption("not_selected");
    console.log("display question form", questionForm);
    if (questionForm.questions != undefined) {
      console.log("is it live ?", isLive);
      const currentQ = questionForm.questions[currentQueston];
      const wordCloudMulti =
        questionForm.isWordCloud && currentQ?.allowMultiple;
      const questionLocked = currentQ?.answered && !wordCloudMulti;

      if (isLive) {
        if (!questionForm.liveData.waiting) {
          console.log(questionForm);
          console.log("display", currentQueston);
          if (!questionLocked) {
            if (wordCloudMulti && questionIntroCompletedRef.current[currentQueston]) {
              setShowAnimation(false);
              setShowQuestion(true);
              if (isLive) {
                applyAdminTimer(liveTimers?.[currentQueston]);
              }
            } else {
              setIsTimeUp(false);
              setShowQuestion(false);
              setShowAnimation(true);
              setTimeout(() => {
                startCircleAnimation();
              }, 2000);
            }
          } else {
            setShowAnimation(false);
            setShowQuestion(true);
          }

          console.log(currentQueston);
          console.log("slidedata", slideData);
          if (slideData?.slideHistory?.[currentQueston] !== undefined) {
            console.log("current question", currentQueston);
            console.log(
              "updating pointer after checking live",
              slideData.slideHistory[currentQueston]
            );
            console.log("slidehistory", slideData.slideHistory);
            setPointerTimestamp(slideData.slideHistory[currentQueston]);
          }
        }
      } else {
        if (questionForm.isQuiz || questionForm.isWordCloud) {
          setShowQuestion(true);
          console.log("irritating bug caused by this !");
          configureTimer(questionForm?.questions[currentQueston].time);
        } else {
          console.log(
            "Dispaly bug ---",
            questionForm?.questions[currentQueston]?.answered
          );
          setShowQuestion(true);
        }
      }
    }
  }

  useEffect(() => {
    const storedSession = sessionStorage.getItem("userData");
    const themeData = sessionStorage.getItem("themeData");
    if (storedSession && themeData) {
      setThemeData(JSON.parse(themeData));
      setUserData(JSON.parse(storedSession));
      console.log("session state updated!");
    } else {
      navigate("/login");
    }
  }, []);

  function selectOption(option) {
    console.log(option);
    setSelectedOption(option);
  }

  useEffect(() => {
    if (userData != null) {
      const liveCountRef = doc(
        database,
        `sessions/${userData.sessionId}/reports/${themeData.themeName}`
      );

      // Increment the live user count on mount
      updateDoc(liveCountRef, { "live.count": increment(1) })
        .then(() => console.log("live count updated!"))
        .catch((error) => {
          if (error.code === "not-found") {
            // If the document doesn't exist, create it with count = 1
            setDoc(liveCountRef, { live: { count: 1 } }, { merge: true })
              .then(() => console.log("Document created and count incremented"))
              .catch((setError) =>
                console.error("Error creating document:", setError)
              );
          } else {
            console.error("Error incrementing count:", error);
          }
        });

      // Decrement the live user count when the user navigates away
      const handleBeforeUnload = () => {
        updateDoc(liveCountRef, { "live.count": increment(-1) })
          .then(() => console.log("Decremented live user count"))
          .catch((error) => {
            if (error.code === "not-found") {
              // If the document doesn't exist, create it with count = 0 (or leave unchanged)
              setDoc(liveCountRef, { live: { count: 0 } }, { merge: true })
                .then(() => console.log("Document created during decrement"))
                .catch((setError) =>
                  console.error(
                    "Error creating document during decrement:",
                    setError
                  )
                );
            } else {
              console.error("Error decrementing count:", error);
            }
          });
      };

      // Attach the event listener
      window.addEventListener("beforeunload", handleBeforeUnload);

      // Cleanup the listener and decrement on component unmount
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        updateDoc(liveCountRef, { "live.count": increment(-1) })
          .then(() => console.log("Decremented live user count on unmount"))
          .catch((error) => {
            if (error.code === "not-found") {
              // If the document doesn't exist, create it with count = 0 (or leave unchanged)
              setDoc(liveCountRef, { live: { count: 0 } }, { merge: true })
                .then(() =>
                  console.log("Document created during unmount decrement")
                )
                .catch((setError) =>
                  console.error(
                    "Error creating document during unmount decrement:",
                    setError
                  )
                );
            } else {
              console.error("Error decrementing count on unmount:", error);
            }
          });
      };
    }
  }, [userData]);

  useEffect(() => {
    if (userData != null) {
      const reportDoc = doc(
        database,
        `sessions/${userData.sessionId}/themes/${themeData.themeName}`
      );

      const unsubscribe = onSnapshot(
        reportDoc,
        (docSnapshot) => {
          if (docSnapshot.exists()) {
            console.log("session/theme LISTNER ADDED");
            let getData = docSnapshot.data();
            clearTimer();
            initalizePolling();
            setTriggerFromLive(true);
            setShowQuestion(false);
            setIsTimeUp(false);
            setWaitingScreen(getData.liveData.waiting);
            if (!getData.isWordCloud) {
              fetchCounterLive(
                getData.liveData.slide,
                getData.questions[getData.liveData.slide].options.length,
                getData
              );
            }
          } else {
            console.warn("Document does not exist.");
          }
        },
        (error) => {
          console.error("Error fetching Firestore document: ", error);
        }
      );

      return () => unsubscribe();
    }
  }, [userData]);

  function listenTimers() {
    if (userData === null) return;
    console.log("trying to listining timers!");
    const reportDoc = doc(
      database,
      `sessions/${userData.sessionId}/reports/${themeData.themeName}`
    );

    const unsubscribe = onSnapshot(
      reportDoc,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          let getData = docSnapshot.data();
          console.log("timers", getData.timers);
          setLiveTimers(getData.timers);
        } else {
          console.warn("Document does not exist.");
        }
      },
      (error) => {
        console.error("Error fetching Firestore document: ", error);
      }
    );

    return () => unsubscribe();
  }

  function listenThemeChange() {
    const reportDoc = doc(database, `sessions/${userData.sessionId}`);

    const unsubscribe = onSnapshot(
      reportDoc,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          let getData = docSnapshot.data();
          console.log("current theme", getData.currentTheme);
          if (themeData.themeName != getData.currentTheme) {
            fetch(
              process.env.REACT_APP_FETCH_THEMEDATA +
                "?sessionId=" +
                userData.sessionId +
                "&userId=" +
                userData.userId +
                "&organizationId=" +
                userData.organizationId
            ) // Replace with your API URL
              .then((response) => {
                if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
              })
              .then((json) => {
                sessionStorage.setItem("themeData", JSON.stringify(json));
                window.location.reload();
                console.log(json);
              })
              .catch((err) => {
                console.log(err.message); // Handle error
              });
          }
          // setLiveTimers(getData.timers);
        } else {
          console.warn("Document does not exist. for current theme check");
        }
      },
      (error) => {
        console.error(
          "Error fetching Firestore document: for current theme check",
          error
        );
      }
    );

    return () => unsubscribe();
  }

  useEffect(() => {
    if (!isLive || currentQueston == null) {
      return;
    }
    if (!questionIntroCompletedRef.current[currentQueston]) {
      return;
    }
    if (liveTimers && liveTimers[currentQueston] !== undefined) {
      applyAdminTimer(liveTimers[currentQueston]);
    }
  }, [liveTimers, currentQueston, isLive]);

  const processEmptyOptions = (process, optionsCount) => {
    const counter = [];
    for (let i = 0; i < optionsCount; i++) {
      if (process && process.total && process.total[i] !== undefined) {
        counter.push(process.total[i]);
      } else {
        counter.push(0);
      }
    }
    return counter;
  };

  function convertToPercentage(countArray) {
    // Calculate the total sum of all counts
    const total = countArray.reduce((sum, count) => sum + count, 0);

    // If the total is 0, return an array of 0s to avoid division by zero
    if (total === 0) {
      return countArray.map(() => 0);
    }

    // Calculate the percentage for each count in the array and round to remove decimals
    let percentageData = countArray.map((count) => {
      let percentage = (count / total) * 100;
      let roundedPercentage = Math.round(percentage); // Round the percentage
      return roundedPercentage;
    });

    return percentageData;
  }

  const fetchCounter = (target, options, formData) => {
    if (userData != null) {
      const counterRef = doc(
        database,
        `sessions/${userData.sessionId}/reports/${themeData.themeName}/${target}/counter`
      );
      console.log(
        `sessions/${userData.sessionId}/reports/${themeData.themeName}/${target}/counter`
      );
      getDoc(counterRef)
        .then((database) => {
          if (database.exists) {
            const process = database.data();
            const processedCounter = processEmptyOptions(process, options);
            let mapData = convertToPercentage(processedCounter);
            setBarChartLables(formData.questions[target].options);
            setBarChartPercentages(mapData);
          } else {
            console.log("No document found");
            console.log(Array(options).fill(0));
          }
        })
        .catch((err) => {
          console.error("Error checking document:", err);
        });
    } else {
      console.log("not able to initiate fetch counter");
    }
  };

  const fetchCounterLive = (target, options, formData) => {
    if (formData?.isWordCloud) {
      return;
    }
    if (userData != null) {
      const counterRef = doc(
        database,
        `sessions/${userData.sessionId}/reports/${themeData.themeName}/${target}/counter`
      );

      console.log("try-check any chartData exist!");
      const unsubscribe = onSnapshot(
        counterRef,
        (snapshot) => {
          if (snapshot.exists()) {
            const process = snapshot.data();
            const processedCounter = processEmptyOptions(process, options);
            const mapData = convertToPercentage(processedCounter);
            setBarChartLables(formData.questions[target].options);
            setBarChartPercentages(mapData);
          } else {
            console.log("No chartData found for " + target);
          }
        },
        (error) => {
          console.error("Error listening to document:", error);
        }
      );

      // Return the unsubscribe function for cleanup if needed
      return unsubscribe;
    } else {
      console.log("Not able to initiate fetch counter");
    }
  };

  

  function handleTimerExpired() {
    stopLocalTimer();
    setTime("00:00");
    const wordCloudMulti =
      questionForm?.isWordCloud &&
      questionForm?.questions?.[currentQueston]?.allowMultiple;

    if (questionForm?.isQuiz || questionForm?.isWordCloud) {
      setIsTimeUp(true);
      if (!wordCloudMulti) {
        setQuestionForm((prevForm) => ({
          ...prevForm,
          questions: prevForm.questions.map((question, questionI) =>
            questionI === currentQueston
              ? { ...question, answered: true }
              : question
          ),
        }));
      }
      return;
    }
    skipQuestion();
  }

  function skipQuestion() {
    const allReportsRef = collection(database, "allReports");

    const userDocRef = doc(
      database,
      `sessions/${userData.sessionId}/reports/${themeData.themeName}/${currentQueston}/${userData.userId}`
    );

    const optionCounterRef = doc(
      database,
      `sessions/${userData.sessionId}/reports/${themeData.themeName}/${currentQueston}/counter/`
    );

    const publicReport = doc(allReportsRef);
    setDoc(userDocRef, {
      option: selectedOption,
      name: userData.name,
      timestamp: serverTimestamp(),
    });
    setDoc(
      optionCounterRef,
      {
        timestamp: serverTimestamp(),
      },
      { merge: true }
    ).catch((error) => {
      console.error("Error incrementing option counter: ", error);
    });
    setDoc(publicReport, {
      name: userData.name,
      themeId: themeData.themeName,
      organizationId: userData.organizationId,
      sessionId: userData.sessionId,
      userId: userData.userId,
      email: userData.email,
      currentQueston: currentQueston,
      source: userData.source,
      option: selectedOption,
      timestamp: serverTimestamp(),
    })
      .then(() => {
        console.log("Document successfully written!");
        setQuestionForm((prevForm) => ({
          ...prevForm, // Keep the previous state
          questions: prevForm.questions.map(
            (question, questionI) =>
              questionI === currentQueston
                ? { ...question, ["answered"]: true } // Add new key-value pair to the specific question
                : question // Keep other questions unchanged
          ),
        }));
        if (!isLive && !showResults) {
          initalizePolling();
        }
      })
      .catch((error) => {
        console.error("Error writing document: ", error);
        // Add error handling here
      });
  }

  function calculateTimeDifference(firestoreTimestamp) {
    const firestoreTimeInMilliseconds =
      firestoreTimestamp.seconds * 1000 +
      firestoreTimestamp.nanoseconds / 1000000;
    console.log("Firestore Time (ms):", firestoreTimeInMilliseconds);

    const currentTime = Date.now();
    console.log("Current Time (ms):", currentTime);

    const adjustedTime = firestoreTimeInMilliseconds;
    console.log("Adjusted Firestore Time (ms):", adjustedTime);

    const timeDifference = currentTime - 9033 - adjustedTime;
    console.log("Final Time Difference (ms):", timeDifference);

    return timeDifference;
  }

  function submitOption() {
    const isWordCloudMode = questionForm?.isWordCloud;
    const currentQuestion = questionForm?.questions?.[currentQueston];
    const wordCloudAllowsMultiple =
      isWordCloudMode && currentQuestion?.allowMultiple;
    if (isWordCloudMode) {
      const wordCloudValue = newOption.current?.value?.trim();
      if (!wordCloudValue) {
        alert("Please enter text");
        return;
      }
      if (wordCloudValue.length > 25) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "character limit exceed than 25",
        });
        return;
      }
    }
    if (selectedOption != "not_selected" || addOption || isWordCloudMode) {
      const userDocRef = doc(
        database,
        `sessions/${userData.sessionId}/reports/${themeData.themeName}/${currentQueston}/${userData.userId}`
      );

      const totalUsersRef = doc(
        database,
        `sessions/${userData.sessionId}/reports/${themeData.themeName}/${currentQueston}/counter`
      );

      const optionCounterRef = doc(
        database,
        `sessions/${userData.sessionId}/reports/${themeData.themeName}/${currentQueston}/counter/`
      );

      const allAdditionalOptions = collection(database, "allAdditionalOptions");
      const allAdditionalOptionsRef = doc(allAdditionalOptions);
      // Create a new document reference with an auto-generated ID
      const allReportsRef = collection(database, "allReports");
      const publicReport = doc(allReportsRef); // Firestore will generate a unique document ID

      // Check if the user already exists
      if (!addOption && !isWordCloudMode) {
        setDoc(userDocRef, {
          option: selectedOption,
          name: userData.name,
          timestamp: serverTimestamp(),
        });
        setDoc(publicReport, {
          name: userData.name,
          themeId: themeData.themeName,
          organizationId: userData.organizationId,
          sessionId: userData.sessionId,
          userId: userData.userId,
          email: userData.email,
          currentQueston: currentQueston,
          source: userData.source,
          option: selectedOption,
          timestamp: serverTimestamp(),
        });
        setDoc(
          totalUsersRef,
          {
            totalUsers: increment(1),
          },
          { merge: true }
        ).catch((error) => {
          console.error("Error incrementing totalUsers: ", error);
        });
        const optionField = `${selectedOption}`; // Assuming options are dynamically named
        setDoc(
          optionCounterRef,
          {
            total: {
              [optionField]: increment(1), // Ensure `optionField` is treated as part of the nested object
            },
          },
          { merge: true }
        ).catch((error) => {
          console.error("Error incrementing option counter: ", error);
        });
        console.log("inserted in reports");
      } else {
        let getValue = newOption.current.value.trim();
        if (!getValue) {
          alert("Please enter text");
          return;
        }
        const q = query(
          allAdditionalOptions,
          where("sessionId", "==", userData.sessionId),
          where("themeId", "==", themeData.themeName),
          where("currentQueston", "==", currentQueston),
          where("option", "==", getValue)
        );
        getDocs(q)
          .then((querySnapshot) => {
            if (!querySnapshot.empty) {
              // Option exists
              const docRef = querySnapshot.docs[0].ref; // Assuming option is unique
              const existingData = querySnapshot.docs[0].data();

              updateDoc(docRef, {
                count: existingData.count + 1,
              })
                .then(() => {
                  setDoc(userDocRef, {
                    option: 100,
                    name: userData.name,
                    timestamp: serverTimestamp(),
                  });
                  setDoc(publicReport, {
                    name: userData.name,
                    themeId: themeData.themeName,
                    organizationId: userData.organizationId,
                    sessionId: userData.sessionId,
                    userId: userData.userId,
                    email: userData.email,
                    currentQueston: currentQueston,
                    source: userData.source,
                    option: 100,
                    timestamp: serverTimestamp(),
                  });
                  setDoc(
                    totalUsersRef,
                    {
                      totalUsers: increment(1),
                    },
                    { merge: true }
                  ).catch((error) => {
                    console.error("Error incrementing totalUsers: ", error);
                  });
                  console.log("Count incremented successfully.");
                })
                .catch((error) => {
                  console.error("Error updating document:", error);
                });
            } else {
              setDoc(allAdditionalOptionsRef, {
                name: userData.name,
                themeId: themeData.themeName,
                organizationId: userData.organizationId,
                sessionId: userData.sessionId,
                userId: userData.userId,
                email: userData.email,
                currentQueston: currentQueston,
                source: userData.source,
                option: getValue,
                count: 1,
                timestamp: serverTimestamp(),
              });
              setDoc(userDocRef, {
                option: 100,
                name: userData.name,
                timestamp: serverTimestamp(),
              });
              setDoc(publicReport, {
                name: userData.name,
                themeId: themeData.themeName,
                organizationId: userData.organizationId,
                sessionId: userData.sessionId,
                userId: userData.userId,
                email: userData.email,
                currentQueston: currentQueston,
                source: userData.source,
                option: 100,
                timestamp: serverTimestamp(),
              });
              setDoc(
                totalUsersRef,
                {
                  totalUsers: increment(1),
                },
                { merge: true }
              ).catch((error) => {
                console.error("Error incrementing totalUsers: ", error);
              });
            }
          })
          .catch((error) => {
            console.error("Error querying documents:", error);
          });
      }

      const finalReportRef = doc(database, `finalReport/${finalReportPointer}`);

      console.log("this pointer timestamp", pointerTimestamp);
      const getMs = calculateTimeDifference(pointerTimestamp);
      const calculateScore = (ms) =>
        Math.max(Math.floor(200 * (1 - ms / 180000)), 0);
      let addPoints = 0;
      console.log("get ms before storing", getMs);
      let points = 0;
      console.log(selectedOption);
      if (
        selectedOption == questionForm.questions[currentQueston].correctOption
      ) {
        console.log(questionForm.questions[currentQueston].points);
        points = questionForm.questions[currentQueston].points;
        addPoints = calculateScore(getMs); // Call the function with ms value
      }

      // setDoc(
      //   finalReportRef,
      //   {
      //     totalPoints: increment(addPoints),
      //     totalQuestions: increment(1),
      //     totalTime: isLive ? increment(getMs) : getMs,
      //   },
      //   { merge: true }
      // ).catch((error) => {
      //   console.error("Error incrementing totalUsers: ", error);
      // });

      //       // const slideDoc = doc(
      //       //       database,
      //       //       `sessions/${userData.sessionId}/reports/${themeData.themeName}`
      //       //     );
      //           getDoc(finalReportRef).then((getPoints) => {
      //             if (getPoints.exists()) {
      //               console.log(getPoints.data());
      //               let fetchData=getPoints.data();

      //               let currentTotalPoints=fetchData.totalPoints;
      //               let currentTotalSeconds=fetchData.totalTime;
      //               addReportToServer(currentTotalPoints,currentTotalSeconds);
      //             }
      //           });

      setDoc(
        finalReportRef,
        {
          totalPoints: increment(addPoints),
          totalQuestions: increment(1),
          totalTime: isLive ? increment(getMs) : getMs,
        },
        { merge: true }
      )
        .then(() => {
          return getDoc(finalReportRef);
        })
        .then((getPoints) => {
          if (!getPoints.exists()) return;

          const fetchData = getPoints.data();

          const currentTotalPoints = fetchData.totalPoints;
          const currentTotalSeconds = fetchData.totalTime;

          addReportToServer(currentTotalPoints, currentTotalSeconds);
        })
        .catch((error) => {
          console.error("Error updating report:", error);
        });

    

      if (wordCloudAllowsMultiple) {
        if (newOption.current) {
          newOption.current.value = "";
        }
        setWordCloudInputDisabled(true);
        setTimeout(() => setWordCloudInputDisabled(false), 2000);
      } else {
        setQuestionForm((prevForm) => ({
          ...prevForm,
          questions: prevForm.questions.map(
            (question, questionI) =>
              questionI === currentQueston
                ? { ...question, answered: true }
                : question
          ),
        }));
        if (!isLive && !showResults) {
          initalizePolling();
        }
      }
    } else {
      alert("Please select the options");
    }
  }

function msToHMS(ms) {
  // guard: anything less than 1 second → 00:00:00
  if (!ms || ms < 1000) {
    return "00:00:00";
  }

  const totalSeconds = Math.floor(ms / 1000);

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

  function addReportToServer(points,time){
    console.log("time-points");
    console.log(points);
    console.log(time);

    // return true;
      const reportData = {
            sessionId: userData.sessionId,
            role: userData.source,
            token: userData.token || null,
            name: userData.name,
            userId: userData.userId,
            gameId: userData.gameId || "",
            organizationId: userData.organizationId,
            points: points,
            time: msToHMS(time),
            reportId: userData.reportId || null,
            ans: "",
          };

          sendReport(reportData)
            .then((apiRes) => {
              console.log("✔ Report API SUCCESS:", apiRes);
            })
            .catch((err) => {
              console.error("❌ Report API FAILED:", err);
            })
            .finally(() => {
              console.log("⚠ finally() executed — success OR fail");
            });
  }

  const [likeEffects, setLikeEffects] = useState([]);

  const handleLike = () => {
    const newEffect = Date.now(); // Unique ID for each animation
    setLikeEffects([...likeEffects, newEffect]);

    const likeUpdate = doc(
      database,
      `sessions/${userData.sessionId}/reports/${themeData.themeName}/${currentQueston}/reactions/`
    );
    console.log(
      `sessions/${userData.sessionId}/reports/${themeData.themeName}/${currentQueston}/reactions/`
    );

    setDoc(
      likeUpdate,
      {
        like: increment(1),
      },
      { merge: true }
    ).catch((error) => {
      console.error("Error whilte updating like increment ", error);
    });

    // Remove the animation after 1 second
    setTimeout(() => {
      setLikeEffects((prev) => prev.filter((id) => id !== newEffect));
    }, 1000);
  };

  useEffect(() => {
    updateHeader({
      backButtonRedirect: "/login?&save=true", // New Back Button Target
    });
    // console.log("convert to seconds---",msToHMS("4554"));
  }, []);
  //       useEffect(()=>{
  //   if(themeData!=null){
  //     const body = document.body;
  //     body.classList.toggle('common-bg');
  //     if (body.classList.contains('common-bg')) {
  //       body.style.backgroundImage = `url(${themeData.background_desk})`;
  //     }
  //   }
  // },[themeData]);

  return (
    <div>
      <div className="polling-page" style={{ textAlign: "center" }}>
        {isLoaded ? (
          waitingScreen && isLive ? (
            <div className="waiting screen">
              <div className="question-title">{questionForm?.title}</div>
              <div className="question-description">
                {questionForm?.description}
              </div>
              <div>
                <img src="/img/cat-image.gif" className="waiting-cat" />
                <div class="wait-info">
                  Please wait for the admin to{" "}
                  <span style={{ color: "#D83307" }}>
                    provide the question.
                  </span>
                </div>
              </div>
            </div>
          ) : questionForm?.liveData.stat ? (
            <>
              <img src="/img/presentation.png" className="end-presentation" />
              <div className="end-text">End of the Presentation</div>
            </>
          ) : (
            <>
              {!isQuestionCompleted ? (
                showAniamtion ? (
                  <>
                    <div className="appear-soon">
                      <div className="show-appear">
                        Question will appear soon
                      </div>
                      <div className="circle-animation" ref={circleRef}>
                        {counter > 0 ? counter : ""}
                      </div>
                    </div>
                  </>
                ) : showQuestion ? (
                  <>
                    {isTimeUp ? (
                      <>
                        <div className="times-up">
                          <div className="times-up-question">
                            {questionForm?.questions[currentQueston]?.text}
                          </div>
                          <img src="/img/times-up.png" />
                          Times Up!
                          <br></br> <br></br>
                       Please wait for the next question to appear on your screen
                        </div>
                      </>
                    ) : !questionForm?.questions[currentQueston]?.answered ||
                      (questionForm?.isWordCloud &&
                        questionForm?.questions[currentQueston]?.allowMultiple) ? (
                      <>
                        {questionForm.isQuiz || questionForm.isWordCloud ? (
                          <div className="timer">{time}</div>
                        ) : (
                          <></>
                        )}

                        {questionForm?.questions?.[currentQueston]?.image &&
                        !questionForm?.isWordCloud && (
                          <img
                            src={
                              process.env.REACT_APP_S3_PATH +
                              questionForm.questions[currentQueston].image
                            }
                            className="question-image"
                            alt="question"
                          />
                        )}

                        <div className="question-name">
                          <div style={{ textAlign: "center" }}>
                            {questionForm?.questions[currentQueston]?.text}
                          </div>
                        </div>
                        <div className="question-container">
                          <div className="option-container">
                            {questionForm?.isWordCloud ? (
                              <input
                                type="text"
                                ref={newOption}
                                className="add-new-option"
                                placeholder="Enter your text"
                                disabled={wordCloudInputDisabled}
                              />
                            ) : (
                              <>
                            {questionForm?.questions[
                              currentQueston
                            ].options.map((option, index) => (
                              <div
                                className={`option ${
                                  selectedOption === index
                                    ? "active-option"
                                    : ""
                                }`}
                                key={index}
                                onClick={() => {
                                  selectOption(index);
                                }}
                                style={{ "--delay": `${index * 0.3}s` }} // Dynamic delay
                              >
                                <input
                                  type="radio"
                                  name="option"
                                  checked={selectedOption === index}
                                  readOnly
                                />
                                {option}
                              </div>
                            ))}

                            {questionForm?.questions[currentQueston]
                              .allowMultiple ? (
                              <>
                                {addOption ? (
                                  <input
                                    type="text"
                                    ref={newOption}
                                    className="add-new-option"
                                    placeholder="Your Opinion"
                                  />
                                ) : (
                                  <div
                                    className="your-openion"
                                    onClick={() => {
                                      setAddOption(true);
                                    }}
                                  >
                                    Add Your Opinion +
                                  </div>
                                )}
                              </>
                            ) : (
                              <div></div>
                            )}
                              </>
                            )}
                          </div>
                          <div className="submit-container">
                            <button
                              className="submit-button"
                              style={{ "--delay": "3s" }}
                              disabled={
                                questionForm?.isWordCloud && wordCloudInputDisabled
                              }
                              onClick={() => {
                                submitOption();
                              }}
                            >
                              Submit
                            </button>
                            {!questionForm?.questions[currentQueston]
                              .required ? (
                              <button
                                className="skip-button"
                                onClick={() => {
                                  skipQuestion();
                                }}
                              >
                                Skip
                              </button>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div
                            className="like-animation-container"
                            style={{ display: isLive ? "block" : "none" }}
                          >
                            <button
                              className="like-button"
                              onClick={handleLike}
                            >
                              <FontAwesomeIcon icon={faThumbsUp} />
                            </button>
                            {likeEffects.map((effect) => (
                              <div key={effect} className="like-icon">
                                <FontAwesomeIcon icon={faThumbsUp} />
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="already-answered">
                        {showResults ? (
                          isLive ? (
                            <div>
                              {" "}
                              <div class="admin-wait-info-with-chart">
                                Thank you for your response. {" "}
                                <br></br> Please wait for the next question to {" "}
                                <span style={{ color: "#D83307" }}>
                                  appear on your screen
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div></div>
                          )
                        ) : (
                          <div>
                            {isLive ? (
                              <div>
                                <div class="admin-wait-info">
                                  Thank you for your response.{" "}
                                  <br></br> Please wait for the next question to {" "}
                                  <span style={{ color: "#D83307" }}>
                                    appear on your screen.
                                  </span>
                                </div>
                                <img
                                  src="/img/cat-image.gif"
                                  className="waiting-cat"
                                />
                              </div>
                            ) : (
                              <div></div>
                            )}
                          </div>
                        )}

                        <br />

                        {showResults ? (
                          <div className="chart-holder">
                            <div className="chart-question">
                              {questionForm?.questions[currentQueston]?.text}
                            </div>
                            <BarChart
                              labels={barCharLables}
                              data={barChartPercentages}
                            ></BarChart>
                          </div>
                        ) : (
                          ""
                        )}
                        {!isLive && showResults ? (
                          <button
                            className="next-button"
                            onClick={() => {
                              window.location.reload();
                            }}
                          >
                            Next
                          </button>
                        ) : (
                          <></>
                        )}
                      </div>
                    )}
                  </>
                ) : (
                  <></>
                )
              ) : (
                <div>
                  <div class="admin-wait-info">
                    All questions completed <br></br>{" "}
                    <span style={{ color: "#D83307" }}>
                      Thank you for participating!
                    </span>
                  </div>
                  <img src="/img/cat-image.gif" className="waiting-cat" />
                </div>
              )}
            </>
          )
        ) : (
          <div className="waiting-screen">
            <div class="loader">
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Polls;
